import { Action, createReducer, on } from '@ngrx/store';
import { IRegulatoryResponse, ITermsAndConditions } from '../models/marketing-options.model';
import * as actions from '../actions';

export const getRegulatoryFeatureKey = 'getRegulatory';

export interface GetRegulatoryState {
  loadRegulatoryResponse: ITermsAndConditions;
  loaded: boolean;
}

export const initialState: GetRegulatoryState = {
  loadRegulatoryResponse: undefined,
  loaded: false
};

export const reducer = createReducer(
  initialState,
  on(actions.loadGetRegulatorySuccess, (state, action) => ({
    ...state,
    loadRegulatoryResponse: action.response,
    loaded: true
  }))
);

export const getRegulatory = (state: GetRegulatoryState) => state.loadRegulatoryResponse;
export const getRegulatoryLoaded = (state: GetRegulatoryState) => state.loaded;
